import { ff_slugify } from '../utils/strings';

/**
 * Module de base permettant d'instancier des modules enfant selon les éléments dans le DOM qui possèdent une classe CSS concordant au nom de la classe JS du module en kebab case avec ou sans le préfixe "ff-".
 */
export default class FF_Module {

  static modules = [];

  static module_instances = {};

  /***
   *      ####   ####  #    #  ####  ##### #####  #    #  ####  #####  ####  #####
   *     #    # #    # ##   # #        #   #    # #    # #    #   #   #    # #    #
   *     #      #    # # #  #  ####    #   #    # #    # #        #   #    # #    #
   *     #      #    # #  # #      #   #   #####  #    # #        #   #    # #####
   *      ####   ####  #    #  ####    #   #    #  ####   ####    #    ####  #    #
   */
  /**
   * @constructor
   * @param {HTMLElement} element Élément pour lequel instancier le module.
   */
  constructor(element) {

    // Si le constructor est appelé directement on bail
    if (new.target === FF_Module) { // eslint-disable-line no-autofix/snakecasejs/snakecasejs
      throw new TypeError('Le constructor de la classe FF_Module ne peut être appelé directement.');
    }

    // Propriétés
    this.elements = {
      container: element
    };
    this.destroyed = false;
    this.module_class_name = Object.entries(FF_Module.modules).find(([module_class_name, module]) => module === this.constructor)[0];
    this.module_css_class = ff_slugify(this.module_class_name);
    this.module_css_class = $(element).is(`.${this.module_css_class}`) ? this.module_css_class : this.module_css_class.replace(/^ff-/, '');

    // Ajout d'une classe CSS qui indique que l'élément a été instancié
    $(element).addClass(`${this.module_css_class}--instanciated`);

    // Ajout de l'instance en tant que "data" à l'élément
    if (typeof element.ff_module_instances === 'undefined') element.ff_module_instances = {};
    element.ff_module_instances[this.module_class_name] = this;

    // Initialisation
    if (typeof this.init === 'function') {
      this.init();
    }

  }

  /***
   *     #####  ######  ####  ##### #####   ####  #   #
   *     #    # #      #        #   #    # #    #  # #
   *     #    # #####   ####    #   #    # #    #   #
   *     #    # #           #   #   #####  #    #   #
   *     #####  ######  ####    #   #    #  ####    #
   */
  /**
   * Détruit l'instance en réinitialisant les changements apportés à l'élément principal.
   */
  destroy() {
    $(this.elements.container).removeClass(`${this.module_css_class}--instanciated`);
    delete this.elements.container.ff_module_instances[this.module_class_name];
    this.destroyed = true;
  }

  /***
   *     # #    # # #####     #    ####  #####   ##   ##### #  ####    #
   *     # ##   # #   #      #    #        #    #  #    #   # #    #    #
   *     # # #  # #   #      #     ####    #   #    #   #   # #         #
   *     # #  # # #   #      #         #   #   ######   #   # #         #
   *     # #    # #   #        ##  ####    #   #    #   #   #  ####  ##
   */
  /**
   * Initialise les systèmes qui instancie les modules selon les éléments dans le DOM.
   * @param {Object} modules Objet des modules importés.
   */
  static init(modules) {

    FF_Module.modules = modules;

    // Lors d'un changement de page Barba, pour tout les modules,
    // on essaye d'aller chercher tous les éléments dans le DOM qui possède une classe concordant au nom de la classe JS du module en kebab case avec ou sans le préfixe "ff-"
    if (typeof barba !== 'object' || typeof barba.hooks !== 'object') return;
    barba.hooks.beforeEnter(() => {
      setTimeout(() => { // *setTimeout pour s'assurer d'initialiser les modules après les autres hooks "beforeEnter"

        // Reset
        if (Object.keys(FF_Module.module_instances).length !== 0) {
          FF_Module.destroy();
        }

        // Instanciation des modules
        Object.entries(FF_Module.modules).forEach(([module_class_name, module]) => {

          // Bail si le module n'est pas un enfant de FF_Module
          if (Object.getPrototypeOf(module) !== FF_Module) { // eslint-disable-line no-autofix/snakecasejs/snakecasejs
            return;
          }

          // Instanciation pour tous les éléments qui concordent
          const module_css_class = ff_slugify(module_class_name);
          const elements_selector = `.${module_css_class}, .${module_css_class.replace(/^ff-/, '')}`;
          $(elements_selector).each((element_i, element) => {
            if (typeof element.ff_module_instances === 'object' && typeof element.ff_module_instances[module_class_name] === 'object') return;
            if (typeof FF_Module.module_instances[module_class_name] === 'undefined') { // Ajout d'une entrée dans le tableau global des instances si elle n'existe pas encore
              FF_Module.module_instances[module_class_name] = [];
            }
            FF_Module.module_instances[module_class_name].push(new module(element)); // eslint-disable-line no-new, new-cap
          });

        });

      });
    });

  }

  /***
   *     #####  ######  ####  ##### #####   ####  #   #     #    ####  #####   ##   ##### #  ####    #
   *     #    # #      #        #   #    # #    #  # #     #    #        #    #  #    #   # #    #    #
   *     #    # #####   ####    #   #    # #    #   #      #     ####    #   #    #   #   # #         #
   *     #    # #           #   #   #####  #    #   #      #         #   #   ######   #   # #         #
   *     #####  ######  ####    #   #    #  ####    #        ##  ####    #   #    #   #   #  ####  ##
   */
  /**
   * Détruit toutes les instances des modules et leurs références qui on été instancié avec FF_Module.init() pour lesquelles l'élément principal n'est plus dans le DOM.
   */
  static destroy() {
    Object.entries(FF_Module.module_instances).forEach(([module_name, module_instances]) => {

      // Destruction des instances pour lesquelles l'élément principal n'est plus dans le DOM
      module_instances.forEach((instance, instance_index) => {
        // if (typeof instance.elements.container === 'undefined' || !document.body.contains(instance.elements.container)) {
        instance.destroy();
        module_instances = module_instances.splice(instance_index, 1);
        // }
      });

      // Suppression de la référence du module si elle est vide
      if (module_instances.length === 0) {
        delete FF_Module.module_instances[module_name];
      }

    });

  }

}
